exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-select {\n\n  font-size: 1.1em;\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.7);\n  border: 1px solid rgba(0, 0, 0, 0.8);\n}\ntr.el-table__row.drop-row td {\n  border: 1px dotted;\n}\n.bg-select.text-white span.q-btn__content {\n  //color: #1a8091;\n  font-size: 1.1em;\n}\n.dark .bg-select.text-white span.q-btn__content {\n  //color: #aee0e8;\n  font-size: 1.1em;\n}\n", ""]);

// exports
